import { Card, DisplayNum } from '../../_components/primitives';

export function StreakCard({
  streak,
  signedIn,
}: {
  streak: number;
  signedIn: boolean;
}) {
  // Match the legacy below-card chip: only surface a streak ≥ 2.
  if (!signedIn || streak < 2) return null;
  return (
    <Card padded={false}>
      <div
        style={{
          padding: '18px 20px 20px',
          background:
            'linear-gradient(160deg, var(--coral-soft), transparent 80%)',
          borderRadius: 'var(--radius-lg)',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'baseline', gap: 8 }}>
          <DisplayNum size={44}>{streak}</DisplayNum>
          <span
            style={{
              fontFamily: 'var(--font-sans)',
              fontSize: 13,
              color: 'var(--fg-2)',
            }}
          >
            day streak
          </span>
        </div>
        <p style={{ marginTop: 6, fontSize: 13, color: 'var(--fg-2)' }}>
          Solve today&apos;s round to keep it going. Missed days end the streak
          at midnight ET.
        </p>
      </div>
    </Card>
  );
}
